import {
  InventoryItemUsed,
  InventoryItemUsedUpdateData,
} from './inventory-item-used';

export interface IProduct {
  productName?: string;
  productId?: number;
  id: number;
  title: string;
  description: string;
  sku_plu: string;
  barcode?: string;
  unit: string;
  stock?: number;
  cost: number;
  price: number;
  category: number;
  status: boolean;
  createdAt: Date;
  updatedAt: Date;
  image?: string;
  inventories: InventoryItemUsed[];
  totalRecord: number;
  categoryCount: number;
  productCount?: number;
  imageCount: number;
  descriptionCount: number;
}

export class Product implements IProduct {
  id: number;
  title: string;
  description: string;
  sku_plu: string;
  barcode?: string;
  unit: string;
  stock?: number;
  cost: number;
  price: number;
  category: number;
  status: boolean;
  createdAt: Date;
  updatedAt: Date;
  image?: string | undefined;
  inventories: InventoryItemUsed[];
  inventory?: InventoryItemUsed[];
  totalRecord: number;
  categoryCount: number;
  storeId?: number;
  productId?: number;
  productName?: string | undefined;
  productCount?: number;
  imageCount: number;
  descriptionCount: number;

  constructor(
    id = 0,
    title = '',
    description = '',
    sku_plu = '',
    barcode: string | undefined = undefined,
    unit = '',
    stock = 0,
    cost = 0,
    price = 0,
    category = 0,
    status = false,
    createdAt = new Date(),
    updatedAt = new Date(),
    image = '',
    rawMaterials: InventoryItemUsed[] = [],
    totalRecord: number = 0,
    categoryCount: number = 0,
    imageCount: number = 0,
    descriptionCount: number = 0,
    productId: number = 0,
    productName: string = ''
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.sku_plu = sku_plu;
    this.barcode = barcode;
    this.unit = unit;
    this.stock = stock;
    this.cost = cost;
    this.price = price;
    this.category = category;
    this.status = status;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.image = image;
    this.inventories = rawMaterials;
    this.totalRecord = totalRecord;
    this.categoryCount = categoryCount;
    this.imageCount = imageCount;
    this.descriptionCount = descriptionCount;
    this.productId = productId;
    this.productName = productName;
  }

  get soldOut() {
    return this.stock === 0;
  }

  static fromJSON(json: IProduct) {
    return new Product(
      json.id,
      json.title,
      json.description,
      json.sku_plu,
      json.barcode,
      json.unit,
      json.stock,
      json.cost,
      json.price,
      json.category,
      json.status,
      json.createdAt,
      json.updatedAt,
      json.image,
      json.inventories,
      json.totalRecord,
      json.categoryCount,
      json.imageCount,
      json.descriptionCount,
      json.productId
    );
  }
}

export type ProductUpdateData = Pick<
  IProduct,
  | 'id'
  | 'title'
  | 'description'
  | 'sku_plu'
  | 'unit'
  | 'stock'
  | 'cost'
  | 'price'
  | 'category'
  | 'status'
  | 'image'
> & { inventories: InventoryItemUsedUpdateData[] };

export type ProductCreateData = Pick<
  IProduct,
  | 'title'
  | 'description'
  | 'sku_plu'
  | 'barcode'
  | 'unit'
  | 'stock'
  | 'cost'
  | 'price'
  | 'category'
  | 'status'
  | 'image'
> & { inventories: InventoryItemUsedUpdateData[] };
